import React from 'react';
import { Component } from 'react';

export class HeavyRain extends Component {
render(){
  return (
    <div className="Icon">
     <svg version="1.1" id="rain_x5F_heavy" xmlns="http://www.w3.org/2000/svg" x="0px"
	 y="0px" viewBox="0 0 24 24" enableBackground="new 0 0 24 24">
<g>
	<rect fill="none" width="24" height="24"/>
	<path fillRule="evenodd" clipRule="evenodd" fill="#0072F5" d="M17.2613,22.1666L17.2613,22.1666
		c-0.2552-0.1059-0.3764-0.3983-0.2705-0.6535l1.6271-3.9261c0.1057-0.2552,0.3981-0.3764,0.6535-0.2707
		c0.2552,0.1059,0.3762,0.3985,0.2705,0.6536l-1.6271,3.9261C17.8091,22.1513,17.5163,22.2723,17.2613,22.1666 M2.9718,21.897
		l1.6271-3.9259c0.1057-0.2552-0.0154-0.5478-0.2705-0.6535c-0.2552-0.1057-0.5478,0.0153-0.6535,0.2705l-1.6271,3.9261
		c-0.1059,0.2552,0.0154,0.5478,0.2705,0.6535S2.8661,22.1524,2.9718,21.897 M6.7075,21.8968l1.6271-3.9261
		c0.1057-0.2552-0.0154-0.5478-0.2705-0.6535c-0.2552-0.1057-0.5478,0.0154-0.6535,0.2705l-1.6271,3.9263
		c-0.1057,0.2552,0.0154,0.5476,0.2705,0.6535C6.3092,22.2731,6.6018,22.1522,6.7075,21.8968 M10.4432,21.8965l1.6271-3.9261
		c0.1059-0.255-0.0154-0.5476-0.2705-0.6533c-0.2552-0.1059-0.5478,0.0154-0.6535,0.2705l-1.6271,3.9261
		c-0.1057,0.2552,0.0154,0.5478,0.2705,0.6535S10.3375,22.1518,10.4432,21.8965 M14.1789,21.8965l1.6272-3.9263
		c0.1057-0.2552-0.0155-0.5478-0.2705-0.6535c-0.2554-0.1057-0.5479,0.0153-0.6535,0.2705l-1.6272,3.9263
		c-0.1057,0.255,0.0155,0.5476,0.2705,0.6535C13.7806,22.2725,14.0734,22.1515,14.1789,21.8965 M16.0469,21.8963l0.3432-0.8289
		c0.1059-0.2552-0.0152-0.5476-0.2705-0.6535c-0.2552-0.1057-0.5476,0.0155-0.6535,0.2705l-0.3432,0.8289
		c-0.1059,0.2552,0.0154,0.5476,0.2705,0.6535C15.6486,22.2723,15.9412,22.1513,16.0469,21.8963 M12.3112,21.8965l0.3434-0.8287
		c0.1055-0.2552-0.0155-0.5478-0.2707-0.6535c-0.2552-0.1059-0.5478,0.0153-0.6535,0.2705l-0.3432,0.8289
		c-0.1059,0.255,0.0154,0.5476,0.2705,0.6533C11.9127,22.2727,12.2055,22.1516,12.3112,21.8965 M8.5753,21.8967l0.3434-0.8287
		c0.1057-0.255-0.0154-0.5476-0.2705-0.6535C8.393,20.3088,8.1004,20.43,7.9947,20.6852l-0.3434,0.8287
		c-0.1057,0.2552,0.0154,0.5478,0.2707,0.6535C8.177,22.2731,8.4696,22.152,8.5753,21.8967 M4.8396,21.8968l0.3434-0.8285
		c0.1057-0.2552-0.0155-0.5478-0.2707-0.6535c-0.255-0.1059-0.5478,0.0154-0.6535,0.2705l-0.3432,0.8289
		c-0.1057,0.255,0.0154,0.5476,0.2705,0.6535C4.4415,22.2732,4.7339,22.1522,4.8396,21.8968 M17.0603,19.4508l0.6138-1.4808
		c0.1055-0.2552-0.0155-0.5478-0.2707-0.6535c-0.2552-0.1057-0.5478,0.0155-0.6533,0.2707l-0.6138,1.4808
		c-0.1057,0.255,0.0155,0.5478,0.2705,0.6533C16.662,19.8272,16.9548,19.7059,17.0603,19.4508 M13.3246,19.4511l0.6136-1.4808
		c0.1059-0.2552-0.0154-0.5478-0.2705-0.6535c-0.2554-0.1057-0.5478,0.0153-0.6535,0.2705l-0.6136,1.4808
		c-0.1059,0.2552,0.0154,0.5479,0.2705,0.6535C12.9265,19.8275,13.2189,19.7063,13.3246,19.4511 M9.5889,19.4513l0.6136-1.4808
		c0.1057-0.2552-0.0154-0.5478-0.2705-0.6535c-0.2552-0.1057-0.5478,0.0155-0.6535,0.2705l-0.6136,1.481
		c-0.1059,0.255,0.0154,0.5478,0.2705,0.6535C9.1906,19.8277,9.4832,19.7065,9.5889,19.4513 M5.8532,19.4516l0.6136-1.4808
		c0.1057-0.2552-0.0155-0.5478-0.2707-0.6535c-0.255-0.1057-0.5478,0.0154-0.6535,0.2705l-0.6134,1.4808
		c-0.1057,0.2552,0.0154,0.5479,0.2705,0.6535C5.4549,19.8281,5.7475,19.7068,5.8532,19.4516"/>
	<g>
		<path fillRule="evenodd" clipRule="evenodd" fill="#FFFFFF" d="M5.249,15.4995c-1.5166,0-2.75-1.2334-2.75-2.75
			c0-1.126,0.6777-2.1265,1.7266-2.5483l0.3486-0.1401L4.5361,9.687C4.5137,9.4614,4.499,9.2324,4.499,8.9995
			c0-3.584,2.916-6.5,6.5-6.5c2.9912,0,5.583,2.0288,6.3018,4.9331l0.0908,0.3677l0.3789,0.0117
			c2.0908,0.0664,3.7285,1.7515,3.7285,3.8374c0,2.123-1.7266,3.8501-3.8496,3.8501H5.249z"/>
		<path fill="#1D1D33" d="M10.9994,2.9994c2.7609,0,5.1527,1.8724,5.8163,4.5533l0.182,0.7352l0.7571,0.0239
			c1.8194,0.0575,3.2446,1.5236,3.2446,3.3374c0,1.8473-1.5028,3.3501-3.35,3.3501h-12.4c-1.2407,0-2.25-1.0093-2.25-2.2499
			c0-0.921,0.5547-1.7391,1.413-2.0842l0.6991-0.2811L5.0341,9.6346c-0.0233-0.226-0.0347-0.4337-0.0347-0.6351
			C4.9994,5.691,7.691,2.9994,10.9994,2.9994 M10.9994,1.9994c-3.866,0-7,3.1331-7,7.0001c0,0.2499,0.015,0.4958,0.04,0.7379
			c-1.194,0.4801-2.04,1.6449-2.04,3.0121c0,1.7939,1.455,3.2499,3.25,3.2499h12.4c2.403,0,4.35-1.9479,4.35-4.3501
			c0-2.3558-1.875-4.2629-4.213-4.3369C17.0314,4.2625,14.2834,1.9994,10.9994,1.9994L10.9994,1.9994z"/>
	</g>
</g>
</svg>

    </div>
  );
}
}
export default HeavyRain;